<template>
  <div class="general-frame">
    <div style="text-align: left;">
      <div class="general-search-bar">
        <el-button  type="primary" class="elm-but" @click="popup = 1;popupName ='新增权限组'" v-if="global.power('user.role.add') == true">新增权限组</el-button>
        <el-button
          type="primary"
          class="elm-but"
          :loading="loading"
          @click="userName='',getList()"
        >重置</el-button>
      </div>
      <div>
        <table class="surface">
          <thead>
            <tr>
              <th>权限组名称</th>
              <th>权限组标识</th>
              <th>权限组描述</th>
              <th>权限组人数</th>
              <th>权限组状态</th>
              <th style="width: 400px;">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in  data" :key="index">
              <td>{{item.realName}}</td>
              <td>{{item.name}}</td>
              <td>{{item.comments}}</td>
              <td>{{item.userTotal}}</td>
              <td>{{item.status == 0 ? "正常":"冻结" }}</td>
              <td class="color_button">
                <span @click="edit(item)" v-if="global.power('user.role.update') == true" class="margin-but">
                  <i class="el-icon-edit"></i>编辑权限
                </span>

                <router-link :to="{path:'/userDetails', query:{ name:item.name}}">
                  <span>
                    <i class="el-icon-search"></i>查看人员
                  </span>
                </router-link>
              </td>
            </tr>
          </tbody>
          <noData :data="data" />
        </table>
        <el-pagination
          background
          style="text-align: center;margin-top:15px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum "
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增编辑 -->
    <div class="window" v-show="popup == 1">
      <div style="width:50%;background:#FFF;border-radius: 4px;">
        <div class="window_top">
          <span>{{popupName}}</span>
          <i class="el-icon-close" @click="popup = 0;eliminate(form)"></i>
        </div>
        <div style="padding: 20px;">
          <el-form :label-position="labelPosition" label-width="100px" ref="form" :model="form">
            <el-form-item
              label="权限组名称"
              prop="realName"
              :rules="[{ required: true, message: '权限组名称不能为空'},]"
            >
              <el-input v-model="form.realName" placeholder="请输入权限组名称"></el-input>
            </el-form-item>
            <el-form-item
              label="权限组标识"
              prop="name"
              :rules="[{ required: true, message: '权限组标识不能为空'},]"
            >
              <el-input v-model="form.name" placeholder="请输入权限组标识 "></el-input>
            </el-form-item>
            <el-form-item
              label="权限组描述"
              prop="comments"
              :rules="[{ required: true, message: '权限组描述不能为空'},]"
            >
              <el-input v-model="form.comments" placeholder="请输入权限组描述 "></el-input>
            </el-form-item>
          </el-form>
          <el-transfer
            style="text-align: left;"
            class="flex transfer"
            v-model="value"
            filterable
            :left-default-checked="[]"
            :right-default-checked="[]"
            :render-content="renderFunc"
            :titles="['未拥有的权限', '已拥有的权限']"
            :button-texts="['到左边', '到右边']"
            :format="{
                              noChecked: '${total}',
                              hasChecked: '${checked}/${total}'
                            }"
            :data="dataItem"
          ></el-transfer>
        </div>
        <div class="window_bottom">
          <el-button type="primary" @click="submit('form')">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import noData from "@/components/html/noData";
export default {
  components: {
      noData
  },
  data() {
    return {
      pageSize: 10, //每页10条
      pageNum : 1, //当前页码
      total: 0,
      popupName: "新增人员",
      userName: "",
      labelPosition: "right",
      data: null,
      dataItem: [],
      loading: false,
      popup: 0,
      form: {
        realName: "",
        name: "",
        comments: "",
      },
      value: [],
      pinyin: [],
      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      },
      renderFunc(h, option) {
        return <span>{option.label}</span>;
      },
    };
  },
  methods: {
    getList() {
      var that = this;
      that.loading = true;
      that.get("/authority/list", {
          userName: that.userName,
          pageSize: this.pageSize,
          pageNum : this.pageNum ,
        })
        .then(function (res) {
          that.data = res.data.rows;
          that.total = res.data.total;
          that.loading = false;
        });
    },

    //pageNum  改变时会触发
    handleCurrentChange(pageNum ) {
      this.pageNum  = pageNum ;
      this.getList(); //调用终端数据接口
    },
    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },

    //角色管理接口
    roleManagement() {
      let that = this;
      that.dataItem = [];
      that.get("/authority/detailFun", {}).then((res) => {
        if (res) {
          res.data.rows.forEach(function (c, index) {
            that.pinyin.push(c.name);
            that.dataItem.push({
              key: c.id,
              label: c.name,
              pinyin: that.pinyin[index], //添加数据时设置pinyin的索引
            });
          });
        }
      });
    },

    //清除
    eliminate() {
      this.form.id = null;
      this.$refs.form.resetFields();
      this.value = []
    },

    //编辑
    edit(item) {
      this.popup = 1;
      this.popupName = "权限编辑";
      this.form.id = item.id;
      this.form.realName = item.realName;
      this.form.name = item.name;
      this.form.comments = item.comments;
      // 隐士转换
      const a = "[" + item.funcIds + "]";
      const b = eval("(" + a + ")");
      this.value = b;
    },

    //提交
    submit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var that = this;
          if (that.popupName === "权限编辑") {
            var a = this.value;
            var b = a.toString();
            this.post("/authority/edit", {
              id: this.form.id,
              funcIds: b,
              comments: this.form.comments,
            }).then((res) => {
              if (res.data.code == 200) {
                that.getList();
                that.popup = 0;
                that.eliminate();
                that.$message({
                  type: "success",
                  message: "修改成功!",
                });
              } else {
                that.$message.error(res.data.msg);
              }
            });
          } else {
            this.post("/authority/add", this.form).then(function (res) {
              if (res.data.code == 200) {
                that.getList();
                that.popup = 0;
                that.eliminate();
                that.$message({
                  type: "success",
                  message: "新增成功!",
                });
              } else {
                that.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.roleManagement();
  },
  created: function () {},
};
</script>

<style scoped>
.transfer  /deep/ .el-input--prefix .el-input__inner{
  background: #FFF;
    border: 0px;
    box-shadow: navajowhite;
    box-shadow: none;
    color: #000;
    border: 1px solid;
    border: 1px solid #DCDFE6;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/personal/user.vue